import {
    Avatar,
    Card,
    Cell,
    Header,
    Spacing,
    Spinner
} from '@vkontakte/vkui';
import React, {useEffect, useState} from 'react';
import {getWeeklyPlayerRating} from "../../services/player";
import BackgroundLetters from "../../components/Background/Background";

// Общие стили для карточек рейтинга
const ratingCardClass = "w-full bg-gray-800 text-gray-400 border border-gray-700/40";

function Rating() {
    return (
        <>
            <BackgroundLetters/>

            <div className={"relative z-10 flex flex-col p-4 items-center mx-auto w-full max-w-lg text-gray-400"}>
                {/* Общий ограниченный контентный блок повторяет ширину max-w-lg главной страницы */}
                <Spacing size={12}/>
                <div className={"w-full"}>
                    <PlayerList/>
                </div>
                <Spacing size={32}/>
            </div>
        </>
    )
}

function PlayerList() {
    // Состояние для общего рейтинга
    const [players, setPlayers] = useState([]);
    const [currentPlayer, setCurrentPlayer] = useState({});
    const [currentPlayerRank, setCurrentPlayerRank] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    // Загрузка общего рейтинга при монтировании компонента
    useEffect(() => {
        getWeeklyPlayerRating().then(resp => {
            const data = resp.data.response;
            setCurrentPlayer(data.player);
            setCurrentPlayerRank(data.player_rank);
            setPlayers(data.winners || []);
        }).catch(err => {
            console.log("getTopWinners error:", err);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    return (
        <div className={"flex flex-col gap-4 w-full"}>
            {isLoading ? <Spinner size={"large"}/> : (
                <>
                    {players.length > 0 ? (
                        <Card className={ratingCardClass}>
                            <Spacing size={12}/>
                            <p className={"text-xs text-gray-400 px-4"}>Weekly leaderboard</p>
                            <Spacing size={12}/>
                            {players.map(player => (
                                <Cell before={<Avatar src={player.avatar}/>}
                                      key={player.id}
                                      subtitle={`Points: ${player.weekly_score || 0} | Games: ${player.weekly_games || 0}`}
                                      disabled={true}
                                      className={"vkui-cell-text"}
                                >
                                    <span className={"text-gray-400"}>{player.name}</span>
                                </Cell>
                            ))}
                            <Spacing size={12}/>
                        </Card>
                    ) : (
                        <Card className={ratingCardClass}>
                            <Header className={"text-gray-400"}>No rating data yet</Header>
                        </Card>
                    )}

                    <Card className={ratingCardClass}>
                        <Header subtitle={`Rank position: ${currentPlayerRank}`}>
                            <span className={"text-gray-400"}>Your rating</span>
                        </Header>
                        <Cell before={<Avatar src={currentPlayer.avatar}/>}
                              key={currentPlayer.id}
                              subtitle={`Weekly points: ${currentPlayer.weekly_score || 0} | Games: ${currentPlayer.weekly_games || 0}`}
                              disabled={true}
                              className={"vkui-cell-text"}
                        >
                            <span className={"text-gray-400"}>{currentPlayer.name}</span>
                        </Cell>
                        <Spacing size={12}/>
                    </Card>
                </>
            )}
        </div>
    );
}

export default Rating;
